import { IGlobalState } from '../states/GlobalState';
import { GetConfiguration } from "../utils/config";
import Auth, { AuthDataType} from '../types/auth';
import { User } from 'oidc-client';
import { getHeadersForSSO, handleErrorsForSSO } from './identityService';
import { Principal, PrincipalSearchModel } from '../models/principal';
import { PrincipalAuth } from '../models/principalAuth';
import { SerializationHelper } from '../serializable/helper';
import { Result } from '../models/objects';

export const getPrincipals = (ip: string, authData: AuthDataType, user: User, model: PrincipalSearchModel): Promise<Result<Principal>> => {        
    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    console.log('Get Principals body data', JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/principal/search`
    console.log('Get Principals', url);
    return window.fetch(url, {
        method: 'POST',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(model)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            //console.log(`GetPrincipals ("${authData.user}") -> letti ${json.ResultList.length} principals`);
            console.log('GetPrincipals recuperato json: ' + JSON.stringify(json));
            const rv = json as Result<Principal>;
            let result: Result<Principal> = new Result<Principal>();
            result.ResultList = [];
            result.ListLength = 0;
            let items: Principal[] = rv.ResultList;
            items.forEach(item  => {
                let pp = SerializationHelper.toInstance(new Principal(), JSON.stringify(item));
                result.ResultList.push(pp);
            });
            result.ListLength = rv.ListLength;  
            // console.log('GetPrincipals recuperate: ' + JSON.stringify(rv));
            return result;
        })
        .catch(error => {
            console.log('GetPrincipals error:', error);
            throw error;
        });
}

export const getActiveUsers = (ip: string, authData: AuthDataType, user: User, agencyId: number | null): Promise<Principal[]> => {        
    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    if (agencyId === null) {
        let users: Principal[] = [];
        return Promise.resolve(users);
    }
    const url = `${GetConfiguration().api_url}/principal/activeusers/${agencyId}`
    console.log('Get Principals', url);
    return window.fetch(url, {
        method: 'GET',
        headers: getHeadersForSSO(ip, user)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`Active users ("${authData.user}") -> letti ${json.length} principals`);
            console.log('Active users recuperato json: ' + JSON.stringify(json));
            const rv = json as Principal[];
            let result: Principal[]=[];
            if (rv && rv.length > 0) {
                rv.forEach(item => {
                    let pp = SerializationHelper.toInstance(new Principal(), JSON.stringify(item));
                    result.push(pp);
                });  
            }
            // console.log('GetPrincipals recuperate: ' + JSON.stringify(rv));
            return result;
        })
        .catch(error => {
            console.log('Active users error:', error);
            throw error;
        });
}

export const getPrincipal = (ip: string, authData: AuthDataType, user: User, id: number): Promise<Principal> => {        
    console.log('Get Principal id: ', + id);
    const url = `${GetConfiguration().api_url}/principal/${id}`
    console.log('Get Principal', url);
    return window.fetch(url, {
        method: 'GET',
        headers: getHeadersForSSO(ip, user)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`getPrincipal ("${authData.user}") -> letti ${json.length} principal`);
            console.log('getPrincipal recuperata json: ' + JSON.stringify(json));
            const rv = SerializationHelper.toInstance(new Principal(), JSON.stringify(json));
            return rv;
        })
        .catch(error => {
            console.log('getPrincipal error:', error);
            throw error;
        });
}

export const usernameExists = (ip: string, authData: AuthDataType, user: User, username: string): Promise<boolean> => {
    
    // console.log('Create Principal con oggetto: ', + JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/principal/exists/${username}`
    console.log('Exists username', url);
    return window.fetch(url, {
        method: 'GET',
        headers: getHeadersForSSO(ip, user)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`Exists Principal ("${authData.user}") -> letti ${json.length} exists`);
            // console.log('create Principal recuperata json: ' + JSON.stringify(json));
            const rv = (json as boolean);
            // console.log('updatePrincipal recuperata principal: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('Exists Principal error:', error);
            throw error;
        });
}

export const createPrincipal = (ip: string, authData: AuthDataType, user: User, model: Principal, agencyId: number | null): Promise<Principal> => {
        
    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    if (agencyId === null) {
        agencyId = 0;
    }
    // console.log('Create Principal con oggetto: ', + JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/principal/user/${agencyId}`
    // console.log('Create Principal', url);
    return window.fetch(url, {
        method: 'POST',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(model)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`create Principal ("${authData.user}") -> letti ${json.length} agency`);
            console.log('create Principal recuperata json: ' + JSON.stringify(json));
            const rv = (json as Principal);
            // console.log('updatePrincipal recuperata principal: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('create Principal error:', error);
            throw error;
        });
}

export const updatePrincipal = (ip: string, authData: AuthDataType, user: User, model: Principal): Promise<Principal> => {
        
    // console.log('Insert/Update Principal con oggetto: ', + JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/principal`
    // console.log('Update Principal', url);
    return window.fetch(url, {
        method: 'POST',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(model)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`updatePrincipal ("${authData.user}") -> letti ${json.length} agency`);
            console.log('updatePrincipal recuperata json: ' + JSON.stringify(json));
            const rv = (json as Principal);
            // console.log('updatePrincipal recuperata principal: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('updatePrincipal error:', error);
            throw error;
        });
}

export const deletePrincipal = (ip: string, authData: AuthDataType, user: User, id: number): Promise<boolean> => {
        
    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    // console.log('Update Principal con oggetto: ', + JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/principal`
    // console.log('Delete Principal', url);
    return window.fetch(url, {
        method: 'DELETE',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(id)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            // console.log(`deletePrincipal ("${authData.user}") -> letti ${json.length} agency`);
            console.log('deletePrincipal avente id: ' + id);
            const rv = (json as boolean);
            return rv;
        })
        .catch(error => {
            console.log('deletePrincipal error:', error);
            throw error;
        });
}

export const getLicenseNumber = (ip: string, authData: AuthDataType, user: User, id: number | undefined): Promise<number> => {
        
    // console.log('Update Principal con oggetto: ', + JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/principal/license/${id}`;
    // console.log('Get License number', url);
    return window.fetch(url, {
        method: 'GET',
        headers: getHeadersForSSO(ip, user)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            // console.log(`deletePrincipal ("${authData.user}") -> letti ${json.length} agency`);
            console.log('Get License for id: ' + id);
            const rv = (json as number);
            return rv;
        })
        .catch(error => {
            console.log('Get License error:', error);
            throw error;
        });
}
